import { forwardRef } from "react"
import { StyledModal } from "./styled"
import { IModalProps } from "./types"
import { Grid, IconButton, Typography, Paper } from "src/lib"
import { AutoAwesome, Close } from "@mui/icons-material"

const Modal = forwardRef<HTMLDivElement, IModalProps>(({ children, ...props }, ref) => {
    return (
        <StyledModal ref={ref} {...props}>
            <Paper>
                <Grid container justifyContent="space-between">
                    <Grid item>
                        <Grid container gap={3} alignItems="center">
                            <Typography variant="h4">
                                {props.title}
                            </Typography>
                            {props.onClickAIButton && 
                            <IconButton color="primary" onClick={props.onClickAIButton}>
                                <AutoAwesome/>
                            </IconButton>}
                        </Grid>
                    </Grid>
                    <IconButton
                        variant="clean"
                        color="neutral"
                        onClick={props.onClose}
                    >
                        <Close/>
                    </IconButton>
                </Grid>
                <Grid sx={{mt: 2}}>
                    {children}
                </Grid>
            </Paper>
        </StyledModal>
    )
})

export { Modal }